import { useEffect, useState } from "react";
import { flashcardApi } from "../../../api/flashcardApi";
import { storageApi } from "../../../api/storageApi";
import { ResourceType } from "../../../Constants/ResourceType";
import { useParams, useLocation } from "react-router-dom";
import { categoryApi } from "../../../api/categoryApi";
import SearchableSelect from "../../../components/common/SearchableSelect";
import LoadingOverlay from "../../../components/common/LoadingOverlay";
import { aiApi } from "../../../api/aiApi";
import { useAlert } from "../../../context/AlertContext";
import { useLoading } from "../../../context/LoadingContext";
import { AiButton } from "../../../components/common/AIButton";

export default function FlashCardCreatePage() {
    const { state } = useLocation();
    const [frontText, setFrontText] = useState("");
    const [backText, setBackText] = useState("");
    const [transliteration, setTransliteration] = useState("");
    const [usageExample, setUsageExample] = useState("");
    const [preview, setPreview] = useState(null);
    const [selectedCatId, setSelectedCatId] = useState(null);
    const [imageId, setImageId] = useState(null);
    const { showAlert } = useAlert();
    const { showLoading, hideLoading } = useLoading();
    const [isSubmitted, setIsSubmit] = useState();
    const [isAutoGen, setIsAutoGen] = useState();
    // const [searchKey, setSearchKey] = useState("");
    const fetchCategory = async (searchKey) => {
        try {
            const params = {
                pageNumber: 1,
                pageSize: 5,
                filters: {},
                isSortDesc: false,
                sortKey: "",
                seachKey: searchKey
            };

            const res = await categoryApi.getTable(params);
            return res.data.items.map(x => ({
                value: x.id,
                label: x.name
            }));
        }
        finally {

        }
    }
    useEffect(() => {
        const handlePaste  = async (e) => {
            const items = e.clipboardData?.items;
            if (!items) return;

            for (let item of items) {
                if (item.type.startsWith("image/")) {
                    const file = item.getAsFile();

                    // 🔥 dùng lại logic cũ
                    await processFile(file);

                    break; // chỉ lấy 1 ảnh
                }
            }
        };

        window.addEventListener("paste", handlePaste);
        return () => window.removeEventListener("paste", handlePaste);
    }, [])
    const handleFile = async (e) => {
        const f = e.target.files[0];
        await processFile(f);
    };

    const processFile = async (file) => {
        try {
            const f = file;
            if (!f) return;
            const form = new FormData();
            form.append("file", f);
            showLoading();
            const res = await storageApi.uploadTemptFile(form);
            if (res.success) {
                const data = res.data;
                const url = data.url;
                setPreview(url);
                setImageId(data.id);
            }
        }
        finally {
            hideLoading();

        }
    }
    const validateSubmit = () => {
        return !isInvalid(frontText) && !isInvalid(backText);
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSubmit(true);
        if (!validateSubmit()) return;
        try {
            const param = {
                "categoryId": selectedCatId.value,
                "frontText": frontText,
                "backText": backText,
                "transliteration": transliteration,
                "usageExample": usageExample,
                "fileId": imageId
            };
            showLoading()
            const res = await flashcardApi.create(param);
            if (res.success) {
                showAlert("success", "Successfully create flashcard");
                window.history.back();
            }
        } finally {
            hideLoading();
        }
    };
    const handleAutoGen = async () => {
        setIsAutoGen(true);
        if (isInvalid(frontText)) return;
        try {
            const param = {
                "message": frontText
            }
            showLoading();
            const res = await aiApi.genTranslateTextOpenAi(param);
            if (res.success) {
                const message = res.data.targetLang;
                const trans = res.data.transliteration;
                const usage = res.data.usageExample;
                if (message) {
                    setBackText(message);
                    setTransliteration(trans);
                    setUsageExample(usage);
                }
            }
        }
        finally {
            hideLoading();
        }
    }
    const handleAutoGenImage = async () => {
        setIsAutoGen(true);
        if (isInvalid(frontText)) return;
        try {
            const param = {
                "message": frontText
            };
            if (frontText == null || frontText.length <= 0) {
                showAlert("danger", "OriginalText is requre")
                return;
            }
            showLoading();
            const res = await aiApi.genText2Image(param);
            if (res.success) {
                const data = res.data;
                setPreview(data.url);
                setImageId(data.id);
            }
        }
        finally {
            hideLoading();
        }
    }
    const isInvalid = (value, isObject = false) => {
        if (isObject) {
            return value == null
        }
        return !value?.trim();
    }
    return (
        <div className="container mt-4" style={{ maxWidth: 600 }}>
            <h3 className="mb-3">Create Card</h3>

            <form
                className="card p-3 shadow-sm"
                onSubmit={handleSubmit}
            >
                {/* Front */}
                <label className="form-label">
                    Front Text (<span className="text-danger">*</span>)</label>
                <input
                    className={`form-control mb-3 ${isInvalid(frontText) && (isSubmitted || isAutoGen) ? "is-invalid" : ""}`}
                    value={frontText}
                    onChange={(e) => setFrontText(e.target.value)}
                />

                {/* Back + Transliteration + AI */}
                <label className="form-label">Back Text (<span className="text-danger">*</span>)</label>
                <div className="row g-2 mb-3">
                    <div className="col-9">
                        <input
                            className={`form-control mb-2 ${isInvalid(backText) && isSubmitted ? "is-invalid" : ""}`}
                            value={backText}
                            onChange={(e) => setBackText(e.target.value)}
                        />
                        <input
                            className="form-control"
                            placeholder="Transliteration"
                            value={transliteration}
                            onChange={(e) => setTransliteration(e.target.value)}
                        />
                        <input
                            className="form-control"
                            placeholder="Usage Example"
                            value={usageExample}
                            onChange={(e) => setUsageExample(e.target.value)}
                        />
                    </div>

                    <div className="col d-flex align-items-start">
                        <AiButton onClick={handleAutoGen}>
                            Auto Gen
                        </AiButton>
                    </div>
                </div>

                {/* Category */}
                <label className="form-label">Category (<span className="text-danger">*</span>)</label>
                <SearchableSelect
                    fetchApi={fetchCategory}
                    value={selectedCatId}
                    onChange={setSelectedCatId}
                    isInValid={isSubmitted && isInvalid(selectedCatId, true)}

                />

                {/* Image */}
                <label className="form-label mt-3">Image</label>
                <div className="d-flex align-items-center gap-2 mb-3">
                    <input
                        type="file"
                        className={`form-control`}
                        onChange={handleFile}
                    />
                    <AiButton onClick={handleAutoGenImage}>
                        Auto Gen
                    </AiButton>
                </div>

                {preview && (
                    <img
                        src={preview}
                        alt="preview"
                        className="img-fluid rounded mb-3"
                        style={{ maxHeight: 180, objectFit: "cover" }}
                    />
                )}

                {/* Actions */}
                <div className="d-flex gap-2">
                    <button type="submit" className="btn btn-primary">
                        Save Changes
                    </button>

                    <button
                        type="button"
                        className="btn btn-secondary"
                        onClick={() => window.history.back()}
                    >
                        Cancel
                    </button>
                </div>
            </form>
        </div>

    );
}
